import { Component, OnInit, OnDestroy } from '@angular/core';
import { Purpose } from 'src/app/shared/models/purpose.model';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PurposeListService } from './purpose-list.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PurposeCreateModalComponent } from '../purpose-create-modal/purpose-create-modal.component';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Response } from 'src/app/shared/models/response.model';

@Component({
  selector: 'app-purpose-list',
  templateUrl: './purpose-list.component.html',
  styleUrls: ['./purpose-list.component.scss']
})
export class PurposeListComponent implements OnInit, OnDestroy {

  purposes: Purpose[];
  modalOptions: NgbModalOptions;

  paginationOffset: number;
  paginationLimit : number;
  paginationTotal : number;
  paginationMaxPageSize: number;
  searchFilter: string;

  private getAllSubscription: Subscription = null;
  private deleteSubscription: Subscription = null;
  private createSubscription: Subscription = null;
  private editSubscription: Subscription = null;

  constructor(private purposeListService: PurposeListService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.paginationOffset      = 1;
    this.paginationLimit       = 10;
    this.paginationTotal       = 0;
    this.paginationMaxPageSize = 5;
    this.searchFilter          = '';

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

    this.getPurposes();
  }

  ngOnDestroy(): void {
    if (this.getAllSubscription !== null) { this.getAllSubscription.unsubscribe(); }
    if (this.deleteSubscription !== null) { this.deleteSubscription.unsubscribe(); }
    if (this.createSubscription !== null) { this.createSubscription.unsubscribe(); }
    if (this.editSubscription   !== null) { this.editSubscription.unsubscribe(); }
  }

  /**
   * Get filtered purposes list
   */
  getPurposes() {
    this.spinner.show();

    this.getAllSubscription = this.purposeListService.resolvePurposes(this.searchFilter, this.paginationOffset, this.paginationLimit).subscribe((result: Response) => {
      this.purposes        = result.items;
      this.paginationTotal = result.total;

      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      this.toastr.info(error);
      console.error(error);
    });
  }

  /**
   *
   */
  onCreate(): void {
    const modalRef = this.modalService.open(PurposeCreateModalComponent, this.modalOptions);
    modalRef.result.then((data) => {

      // Se crea el registro
      this.spinner.show();
      this.createSubscription = this.purposeListService.create(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getPurposes();
      }, (error) => {
        this.spinner.hide();
        this.toastr.info(error);
        console.error('Error in area created', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param purpose
   */
  onEdit(purpose: Purpose): void {
    const modalRef = this.modalService.open(PurposeCreateModalComponent, this.modalOptions);
    modalRef.componentInstance.purpose = purpose;
    modalRef.result.then((data) => {

      this.spinner.show();
      this.editSubscription = this.purposeListService.update(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getPurposes();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.info(error);
        console.error('Error in area modify', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param id
   * @param index
   */
  onDelete(id: number, index: number): void {
    Swal.fire({
      title: '¿Seguro que desea eliminar?',
      text: '¡No podrás recuperar el registro seleccionado!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Bórralo!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.deleteSubscription = this.purposeListService.delete(id).subscribe(r => {
          this.purposes.splice(index, 1);
          this.spinner.hide();
          Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
        },
        (error) => {
          this.spinner.hide();
          this.toastr.info(error);
          console.error('error to delete item', error);
        });
      }
    });
  }

  /**
   * 
   * @param term 
   */
  onSearch(term: string) {
    this.searchFilter = term;
    this.getPurposes();
  }

  /**
   * 
   */
  onPageChange() {
    this.getPurposes();
  }
}
